import { TOOLS } from "src/common/constants";
import { WidgetI } from "src/types/Widget";
import { ToolsAction } from "../reducers/tools";

export const TOOLS_SET_DATA = `${TOOLS}_SET_DATA` as const;

export const setTools = (payload: WidgetI[]): ToolsAction => ({
  type: TOOLS_SET_DATA,
  payload,
});
